<script setup>
import { onMounted, ref } from 'vue'

const ready = ref(import.meta.env.SSR)

onMounted(() => {
  ready.value = true
})
</script>

<template>
  <slot v-if="ready" />
</template>
